import splt from 'spltjs';
import anime from 'animejs/lib/anime.es.js';

export function banner() {

    splt({
        reveal: true
    });
    
    anime({
        targets: '.reveal',
        translateY: [70, 0],
        direction: 'alternate',
        loop: 0,
        delay: anime.stagger(20),
        easing: 'cubicBezier(.71,-0.77,.43,1.27)'
    });
    
    // for full documentation, visit spltjs.com
}